<template>
    <div>
        <modal :show.sync=show :title=title height='245px' :onSure=modalCb :onCancel=initData>
            <div slot="content" class="spam-content">
                <div><h4 class="tit">垃圾邮件类型</h4><v-select :options="spamtypes" v-model="spamType" ref="select" class="vselect"></v-select></div>
                <div class="ckitem"><checkbox v-model="spamBacklist" :data="true"></checkbox>将发信人列入黑名单，不再接受此人邮件</div>
                <div class="ckitem"><checkbox v-model="spamBacklistAndDel" :data="true"></checkbox>将发信人历史来信移至垃圾箱</div>                
            </div>
        </modal>
        <modal :show.sync=secondShow :title=title2 height='310px' :onSure=secondModalCb :onCancel=initData>
            <div slot="content" class="spam-content spam2">
                <h4 v-if="spamBacklist&&!spamBacklistAndDel">确定将以下发信人列入黑名单？</h4>
                <h4 v-if="!spamBacklist&&spamBacklistAndDel">确定将以下发信人的历史来信移至垃圾箱？</h4> 
                <h4 v-if="spamBacklist&&spamBacklistAndDel">确定将以下选中的发信人加入黑名单？</h4>
                <h4 v-if="spamBacklist&&spamBacklistAndDel">确定将以下发信人的历史来信移至垃圾箱？</h4>                                              
                <ul class="address-list">
                    <li v-for="(addr,key) in uniqueAddr" :key=key><checkbox v-model="addr.select" :data="true"></checkbox><span class="text">{{addr.text}}</span></li>
                </ul>               
            </div>
        </modal>
    </div>
</template>
<script>
import {addBlackBulk, spamCleanMail} from '@/service/mailDetailService'
import { delMail } from '@/service/mailListService'
import vSelect from '@/components/vselect'
import { checkbox, radio } from '@/components/check'
import utils from '@/common/utils'
export default {
    name:'reportSpam',
    // props:{
    //     sshow:{
    //         type:Boolean,
    //         default:false
    //     },
    //     list:[Array],
    //     folderId:[String],
    //     ids:[Array,String],
    //     callback:[Function]
    // },
    data(){
        return {
            show:false,
            title:'举报垃圾邮件',
            title2:'禁用联系人',
            height:'263px',
            spamtypes:['垃圾广告','钓鱼欺诈','违法、反动','其他'],
            spamtypeMap:{
                '垃圾广告':1,
                '钓鱼欺诈':2,
                '违法、反动':3,
                '其他':4
            },
            spamType:1,
            spamBacklist:false,
            spamBacklistAndDel:false,
            uniqueAddr:[],
            spamResult:{
                backlist:'',
                delete:'',
                spam:''
            },
            spamSucessNum:1,
            secondShow:false
        }
    },
    computed: {
    },
    components:{
        vSelect,
        checkbox
    },
    created(){
        this.initData()
    },
    methods:{
        initData(){
            this.spamType=1
            this.spamBacklist=false
            this.spamBacklistAndDel=false
            this.spamSucessNum=1
        },
        modalCb(){
            if(this.spamBacklist||this.spamBacklistAndDel){
                this.nextModal()
            }else{
                delMail({ids: this.ids, folderId: this.folderId, spamType: this.spamtypeMap[this.spamType]})
                .then((res)=>{
                    if(res.status==200){
                        this.spamResult.spam="举报成功！"
                        this.updataList('success')                                                          
                    }else{
                        this.spamResult.spam="举报失败！"  
                        this.updataList('danger')                                                         
                    }
                })
            }
        },
        secondModalCb(l){
            var emails=[];
            this.uniqueAddr.filter(function(item){
                if(item.select){
                    emails.push(item.value);
                }
            });
            delMail({ids: this.ids, folderId: this.folderId, spamType: this.spamtypeMap[this.spamType]})
            .then((res)=>{
                if(res.status==200){
                    this.spamResult.spam="举报成功！";
                    if(emails.length){
                        if(this.spamBacklist){
                            this.addBlackBulkList(emails);                                
                        }
                        if(this.spamBacklistAndDel){
                            this.spamCleanMail(emails.join(','));                                
                        }
                    }else{
                        this.updataList('success');                                                          
                    }
                }else{
                    this.spamResult.spam="举报失败！";   
                    this.updataList('danger');                                                          
                }
            })
        },
        nextModal(){
            this.uniqueAddr=[]
            let address = this.uniqueAddress()
            address.forEach((item)=>{
                var email=item.match(/.*<(.*)>/)[1];
                // 不把自己加入黑名单和删除历史邮件列表                
                if(email!=utils.getStorage('username')){
                    this.uniqueAddr.push({select:true,text:item,value:email});
                }
            })
            // if(this.spamBacklist&&!this.spamBacklistAndDel){
                // this.title2='确定将以下发信人列入黑名单？'
            // }else if(!this.spamBacklist&&this.spamBacklistAndDel){
                // this.title2='确定将以下发信人的历史来信移至垃圾箱？'
            // }else{
                // this.title2='确定将以下发信人列入黑名单并把历史来信移至垃圾箱？'
            // }

            if(this.uniqueAddr.length==0){
                this.secondModalCb()
            }else{
                this.secondShow =true  
            }
        },
        addBlackBulkList(value) {
            addBlackBulk(value).then((data)=>{
                if (data.status==200) {
                    this.spamResult.backlist='加入黑名单'+value.length+'名'                                                                 
                }else if(data.status == 3523){
                    this.spamResult.backlist='黑名单已满'                                                                                         
                }else if(data.status == 3524){
                    this.spamResult.backlist='黑名单已存在'                                                                                                             
                }else if(data.status == 3525){
                    this.spamResult.backlist='不能添加自己到黑名单'                                                                                                             
                }else{
                    this.spamResult.backlist='加入黑名单失败'                                                                                                                
                }
                this.updataList()                      
            });
        },   
        spamCleanMail(value) {
            spamCleanMail({emails: value}).then((data)=>{
                if (data.status==200) {
                    this.spamCleanMailNum=data.data.total;
                    this.spamResult.delete='删除历史来信'+data.data.total+'封';                                                                                                                             
                }else{
                    this.spamResult.delete='删除历史来信失败';                                                                                                                 
                }
                this.updataList();  
            });
        },
        uniqueAddress(){
            var address = [];
            var obj={},newArr=[];            
            this.ids.forEach((item)=>{
                var addr= this.list.filter(function(v){
                    return v.id==item;
                })[0].from;
                address.push(addr);                
            });
            for(var i=0;i<address.length;i++){
                if(!obj[address[i]]){
                    newArr.push(address[i]);
                    obj[address[i]]=1;
                }
            }
            return newArr
        },
        updataList(val){
            var spamListTip='';
            this.spamSucessNum++;
            if(val){
                this.$toast({
                    message: this.spamResult.spam,
                    theme: val
                })      
                val=='success'&&this.callback({op:'spam',ids:this.ids },Promise.resolve({status:200}))                  
            }
            if(this.spamBacklist&&!this.spamBacklistAndDel&&this.spamSucessNum==2){
                spamListTip=this.spamResult.spam+this.spamResult.backlist;
            }else if(!this.spamBacklist&&this.spamBacklistAndDel&&this.spamSucessNum==2){
                spamListTip=this.spamResult.spam+this.spamResult.delete;                
            }else if(this.spamBacklist&&this.spamBacklistAndDel&&this.spamSucessNum==3){
                spamListTip=this.spamResult.spam+this.spamResult.backlist+'，'+this.spamResult.delete;                
            }
            if(spamListTip){
                this.$toast({
                    message: spamListTip,
                    theme: 'success'
                })
                this.callback({op:'spam',ids:this.ids },Promise.resolve({status:200}))
            }                   
        }
    },
    watch:{
        // show:function(){
        //     return this.$emit('update:sshow',this.show)
        // },
        // sshow:function(){
        //     this.show=this.sshow
        // }
    }
}
</script>
<style lang="scss">
.spam-content{
    height:154px;
    text-align:left;
    font-weight: normal;
    padding:0 16px;
    &.spam2{
        height: 198px;
    }
    .tit{
        color: #84848B;
        margin:26px 13px 6px 0;
        font-weight: normal;
        display: inline-block;
    }
    .vselect{
        color: #434354;
        width: 307px;   
        cursor: pointer;     
        .input-control{
            line-height: 30px;
            border: 1px solid #D0D0D0;
            padding-left: 10px;
        }
        .dropmenu{
            padding: 0;
            width:100%;
            z-index: 22;
            li{
                padding-left: 10px;
                height:32px;
                line-height: 32px;
                &.selected:before{
                    display:none;
                }
            }
        }
    }
    .ckitem{
        margin-top: 20px;
        color: #212126;
        >label{
            margin-right: 6px;
        }
    }
    .address-list{
        height: 124px;
        overflow-y: auto;
        border:1px solid #D0D0D0;
        color:#434354;
        padding-left: 10px;
        margin-top: 20px;
        >li{
            margin-top:10px;
        }
        .text{
            margin-left: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/reportSpam.vue